import { createAsyncThunk } from "@reduxjs/toolkit";
import { type TopicType } from "../../../domain/entities/education-topic";
import { type EducationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface UnmarkTopicArgs {
  requestId: string;
  topic: TopicType;
}

export const unmarkTopic = createAsyncThunk<
  TopicType,
  UnmarkTopicArgs,
  { dispatch: EducationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UNMARK_TOPIC, async ({ requestId, topic }, { extra }) => {
  await extra.educationRepo.unmarkTopic(requestId, topic);
  return topic;
});
